<div class="tank-debunker relative pb-4">
  <div class="reorder">
    <re-reorder-buttons (reorder)="onReorder($event)" />
  </div>

  <div class="delete absolute top-4 right-4">
    <re-trash-button (delete)="onDelete()" />
  </div>

  <h2 class="transfer-header text-center">Ship Position</h2>
  <div class="container p-4">
    <div class="container flex justify-center p-4">
      <div class="w-2/3 px-4">
        <re-lat-long-template
          [required]="false"
          [labelWidthPercentage]="20"
        />
      </div>
    </div>

    <div class="mt-4 flex justify-center">
      <div class="flex w-2/3 justify-center">
        <div class="mr-3 text-[.75em]">
          <label for="timezone">Observed Timezone</label>
        </div>
        <div>
          <select
            id="timezoneSelect"
            name="timezone"
            class="focus:shadow-outline w-full rounded border px-4 py-1 focus:outline-none"
          >
            @for (option of timezoneOptions; track option.offset) {
              <option [value]="option.offset">{{ option.name }}</option>
            }
          </select>
        </div>
      </div>
    </div>
  </div>
</div>
